import { AlertDialog as AlertDialogPrimitive } from 'radix-ui';

type AlertDialogPortalProps = React.ComponentProps<
  typeof AlertDialogPrimitive.Portal
>;

export const AlertDialogPortal = ({ ...props }: AlertDialogPortalProps) => (
  <AlertDialogPrimitive.Portal data-slot="alert-dialog-portal" {...props} />
);
